<template>
  <v-list :key="forceUpdate">
    <v-list-group
      color="primary"
      v-for="group in sensorGroup"
      :key="group.title"
      v-model="group.active"
      multiple
      outlined
    >
      <template v-slot:activator>
        <v-list-item-content color="primary">
          <v-list-item-title v-text="group.title"></v-list-item-title>
        </v-list-item-content>
      </template>
      <sensor
        v-for="sensor in group.sensors"
        :key="sensor.uuid"
        :sensor="sensor"
        :selected="sensor.selected"
        :loading="sensor.loading"
        :noData="sensor.noData"
        @click.native="toggleSelection(sensor)"
      ></sensor>
    </v-list-group>
  </v-list>
</template>

<script>
import Sensor from "@/components/miscellaneous/SensorPill.vue";
import colors from "@/utils/colorGenerator.js";

export default {
  components: {
    Sensor,
  },
  props: ["sensorList", "location", "selectedSensors"],
  data: () => ({
    forceUpdate: 0,
  }),
  created() {},
  computed: {
    sensorGroup: {
      get() {
        var grouppedObj = this.sensorList.sensors.reduce((acc, curr) => {
          acc[curr.location] = acc[curr.location] || [];
          acc[curr.location].push(curr);
          return acc;
        }, {});

        this.sensorList.sensors.forEach(function (sensor, index) {
          sensor.color = colors.colorGenerator(index);
          sensor.noData = false;
        });

        return Object.keys(grouppedObj).map((x) => {
          return {
            title: x,
            sensors: grouppedObj[x],
          };
        });
      },
      set(item) {
        return item;
      },
    },
  },
  watch: {
    $route(newValue, oldValue) {
      if (
        oldValue.query.datefrom !== newValue.query.datefrom ||
        oldValue.query.dateto !== newValue.query.dateto
      ) {
        this.sensorGroup = this.sensorGroup.map(({ sensors }) => {
          return sensors.map((sensor, index) => {
            this.$set(sensor, "noData", false);
          });
        });
        this.forceUpdate += 1;
      }
    },
  },
  methods: {
    getSensor(sensorUuid) {
      let sensor = [];
      this.sensorGroup.forEach((item) => {
        sensor.push(
          item.sensors.find((el) => {
            return el.uuid === sensorUuid;
          })
        );
      });
      sensor = sensor.find((item) => typeof item !== "undefined");
      return sensor;
    },
    deleteSensorData(sensor) {
      let indexToDelete = this.selectedSensors.selected.indexOf(sensor.uuid);
      this.selectedSensors.selected.splice(indexToDelete, 1);
      this.selectedSensors.data.splice(indexToDelete, 1);
      this.$emit("selected-sensors-data", {
        selected: this.selectedSensors.selected,
        data: this.selectedSensors.data,
      });
    },
    setSensorData(resp) {
      resp.forEach((element) => {
        element.data.records.forEach((item) => {
          item.created = this.$moment(item.created).unix();
        });
        this.setSensor(element);
        element.data.color = element.sensor.color;
        element.data.name = element.sensor.name;
        this.selectedSensors.selected.push(element.sensor.uuid);
        this.selectedSensors.data.push(element.data);
        this.$emit("selected-sensors-data", {
          selected: this.selectedSensors.selected,
          data: this.selectedSensors.data,
        });
      });
    },
    setSensor(sensor) {
      this.sensorGroup.forEach((el) => {
        el.sensors.forEach((element) => {
          if (element.uuid === sensor.sensor.uuid) {
            this.$set(element, "loading", false);
            this.$set(element, "selected", true);
          }
        });
      });
    },
    toggleSelection(sensor) {
      if (this.selectedSensors.selected.includes(sensor.uuid)) {
        this.deleteSensorData(sensor);
        sensor.selected = false;
        this.$forceUpdate();
      } else {
        sensor.loading = true;
        this.$forceUpdate();
        new Promise((resolve, reject) => {
          this.$emit("fetch-sensor-data", sensor.uuid, function (callback) {
            resolve(callback);
          });
        }).then((resp) => {
          if (resp.data.records.length !== 0) {
            this.selectedSensors.selected.push(sensor.uuid);
            sensor.loading = false;
            sensor.selected = true;
            resp.data.records.forEach((item) => {
              item.created = this.$moment(item.created).unix();
            });
            resp.data.color = sensor.color;
            resp.data.name = sensor.name;
            this.selectedSensors.data.push(resp.data);
            this.$emit("selected-sensors-data", {
              selected: this.selectedSensors.selected,
              data: this.selectedSensors.data,
            });
            sensor.loading = false;
            sensor.selected = true;
          } else {
            sensor.noData = true;
            sensor.loading = false;
            sensor.selected = false;
          }
          this.$forceUpdate();
        });
      }
    },
  },
};
</script>

<style></style>
